/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { InputType } from '../business-sign-up';

export interface IBusinessSignUpInputProps {
    id?: string;
    type: InputType;
    value?: string;
    pattern?: string;
    className: string;
    maxLength?: string;
    isRequired: boolean;
    fieldReference?: React.RefObject<HTMLInputElement>;
    onChange?(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
}

export interface IBusinessSignUpInput {
    key: string;
    AddressItem: INodeProps;
    label: React.ReactNode;
    alert: React.ReactNode;
    input: React.ReactNode;
}

const GetMaxLength = (maxLength?: string): number | undefined => {
    if (maxLength) {
        const parsedMaxLength = Number.parseInt(maxLength, 10);
        if (!isNaN(parsedMaxLength)) {
            return parsedMaxLength;
        }
    }

    return undefined;
};

export const SignUpInput: React.FC<IBusinessSignUpInputProps> = ({
    id,
    type,
    value,
    pattern,
    className,
    maxLength,
    isRequired,
    onChange,
    fieldReference
}) => {
    if (type === InputType.TextArea) {
        return (
            <textarea
                id={id}
                name={id}
                value={value}
                className={`${className}-input-area ${className}-${id}`}
                aria-required={isRequired}
                maxLength={GetMaxLength(maxLength)}
                onChange={onChange}
            />
        );
    }

    return (
        <input
            id={id}
            type={type}
            value={value}
            className={`${className}-input ${className}-${id}`}
            pattern={pattern !== '' ? pattern : undefined}
            aria-required={isRequired}
            maxLength={GetMaxLength(maxLength)}
            onChange={onChange}
            ref={fieldReference}
        />
    );
};

export default SignUpInput;
